import {
  COMMENTS_REQUEST,
  COMMENTS_SUCCESS,
  COMMENTS_FAILURE,
  COMMENT_ADD_REQUEST,
  COMMENT_ADD_SUCCESS,
  COMMENT_ADD_FAILURE,
  COMMENT_UPDATE_REQUEST,
  COMMENT_UPDATE_SUCCESS,
  COMMENT_UPDATE_FAILURE,
  COMMENT_DELETE_REQUEST,
  COMMENT_DELETE_SUCCESS,
  COMMENT_DELETE_FAILURE,
  PATIENT_COMMENTS_REQUEST,
  PATIENT_COMMENTS_SUCCESS,
  PATIENT_COMMENTS_FAILURE,
  PATIENT_COMMENT_ADD_REQUEST,
  PATIENT_COMMENT_ADD_SUCCESS,
  PATIENT_COMMENT_ADD_FAILURE,
  PATIENT_COMMENT_UPDATE_REQUEST,
  PATIENT_COMMENT_UPDATE_SUCCESS,
  PATIENT_COMMENT_UPDATE_FAILURE,
  PATIENT_COMMENT_DELETE_REQUEST,
  PATIENT_COMMENT_DELETE_SUCCESS,
  PATIENT_COMMENT_DELETE_FAILURE,
  ESCALATION_COMMENTS_REQUEST,
  ESCALATION_COMMENTS_SUCCESS,
  ESCALATION_COMMENTS_FAILURE,
  LOCATION_ESCALATION_COMMENTS_REQUEST,
  LOCATION_ESCALATION_COMMENTS_SUCCESS,
  LOCATION_ESCALATION_COMMENTS_FAILURE,
  PATIENT_ESCALATION_COMMENTS_REQUEST,
  PATIENT_ESCALATION_COMMENTS_SUCCESS,
  PATIENT_ESCALATION_COMMENTS_FAILURE
} from "./CommentsActions";

const initialState = {
  data: [],
  comment: {},
  error: null,
  isLoading: false,
}

export default function commentsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case COMMENTS_REQUEST:
      return { ...state, isLoading: true }
    case COMMENTS_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false }
    case COMMENTS_FAILURE:
      return { ...state, error: payload.error, isLoading: false }

    case COMMENT_ADD_REQUEST:
      return { ...state, isLoading: true };
    case COMMENT_ADD_SUCCESS:
      return { ...state, comment: payload.data, errors: null, isLoading: false };
    case COMMENT_ADD_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case COMMENT_UPDATE_REQUEST:
      return { ...state, isLoading: true };
    case COMMENT_UPDATE_SUCCESS:
      return { ...state, comment: payload.data, errors: null, isLoading: false };
    case COMMENT_UPDATE_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case COMMENT_DELETE_REQUEST:
      return { ...state, isLoading: true };
    case COMMENT_DELETE_SUCCESS:
      return { ...state, comment: payload.data, errors: null, isLoading: false };
    case COMMENT_DELETE_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PATIENT_COMMENTS_REQUEST:
      return { ...state, isLoading: true }
    case PATIENT_COMMENTS_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false }
    case PATIENT_COMMENTS_FAILURE:
      return { ...state, error: payload.error, isLoading: false }

    case PATIENT_COMMENT_ADD_REQUEST:
      return { ...state, isLoading: true };
    case PATIENT_COMMENT_ADD_SUCCESS:
      return { ...state, comment: payload.data, errors: null, isLoading: false };
    case PATIENT_COMMENT_ADD_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PATIENT_COMMENT_UPDATE_REQUEST:
      return { ...state, isLoading: true };
    case PATIENT_COMMENT_UPDATE_SUCCESS:
      return { ...state, comment: payload.data, errors: null, isLoading: false };
    case PATIENT_COMMENT_UPDATE_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PATIENT_COMMENT_DELETE_REQUEST:
      return { ...state, isLoading: true };
    case PATIENT_COMMENT_DELETE_SUCCESS:
      return { ...state, comment: payload.data, errors: null, isLoading: false };
    case PATIENT_COMMENT_DELETE_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case ESCALATION_COMMENTS_REQUEST:
      return { ...state, isLoading: true }
    case ESCALATION_COMMENTS_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false }
    case ESCALATION_COMMENTS_FAILURE:
      return { ...state, error: payload.error, isLoading: false }

    case LOCATION_ESCALATION_COMMENTS_REQUEST:
      return { ...state, isLoading: true }
    case LOCATION_ESCALATION_COMMENTS_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false }
    case LOCATION_ESCALATION_COMMENTS_FAILURE:
      return { ...state, error: payload.error, isLoading: false }

    case PATIENT_ESCALATION_COMMENTS_REQUEST:
      return { ...state, isLoading: true }
    case PATIENT_ESCALATION_COMMENTS_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false }
    case PATIENT_ESCALATION_COMMENTS_FAILURE:
      return { ...state, error: payload.error, isLoading: false }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/comments/CommentsReducer.js